// US, Canadian, and Mexican zones from https://data.iana.org/time-zones/tzdb/zone.tab.
// Include older names that browsers may still return.
const qrTimeZones = new Set([
	// United States
	'America/New_York',
	'America/Detroit',
	'America/Kentucky/Louisville',
	'America/Kentucky/Monticello',
	'America/Indiana/Indianapolis',
	'America/Indiana/Vincennes',
	'America/Indiana/Winamac',
	'America/Indiana/Marengo',
	'America/Indiana/Petersburg',
	'America/Indiana/Vevay',
	'America/Chicago',
	'America/Indiana/Tell_City',
	'America/Indiana/Knox',
	'America/Menominee',
	'America/North_Dakota/Center',
	'America/North_Dakota/New_Salem',
	'America/North_Dakota/Beulah',
	'America/Denver',
	'America/Boise',
	'America/Phoenix',
	'America/Los_Angeles',
	'America/Anchorage',
	'America/Juneau',
	'America/Sitka',
	'America/Metlakatla',
	'America/Yakutat',
	'America/Nome',
	'America/Adak',
	'Pacific/Honolulu',
	'America/Atka',
	'America/Fort_Wayne',
	'America/Indianapolis',
	'America/Knox_IN',
	'America/Louisville',
	'America/Shiprock',
	'US/Alaska',
	'US/Aleutian',
	'US/Arizona',
	'US/Central',
	'US/East-Indiana',
	'US/Eastern',
	'US/Hawaii',
	'US/Indiana-Starke',
	'US/Michigan',
	'US/Mountain',
	'US/Pacific',
	'Navajo',
	'EST5EDT',
	'CST6CDT',
	'MST7MDT',
	'PST8PDT',
	// Canada
	'America/St_Johns',
	'America/Halifax',
	'America/Glace_Bay',
	'America/Moncton',
	'America/Goose_Bay',
	'America/Blanc-Sablon',
	'America/Toronto',
	'America/Iqaluit',
	'America/Atikokan',
	'America/Winnipeg',
	'America/Resolute',
	'America/Rankin_Inlet',
	'America/Regina',
	'America/Swift_Current',
	'America/Edmonton',
	'America/Cambridge_Bay',
	'America/Inuvik',
	'America/Vancouver',
	'America/Creston',
	'America/Dawson_Creek',
	'America/Fort_Nelson',
	'America/Whitehorse',
	'America/Dawson',
	'America/Coral_Harbour',
	'America/Montreal',
	'America/Nipigon',
	'America/Pangnirtung',
	'America/Rainy_River',
	'America/Thunder_Bay',
	'America/Yellowknife',
	'Canada/Atlantic',
	'Canada/Central',
	'Canada/Eastern',
	'Canada/Mountain',
	'Canada/Newfoundland',
	'Canada/Pacific',
	'Canada/Saskatchewan',
	'Canada/Yukon',
	// Mexico
	'America/Mexico_City',
	'America/Cancun',
	'America/Merida',
	'America/Monterrey',
	'America/Matamoros',
	'America/Chihuahua',
	'America/Ciudad_Juarez',
	'America/Ojinaga',
	'America/Mazatlan',
	'America/Bahia_Banderas',
	'America/Hermosillo',
	'America/Tijuana',
	'America/Ensenada',
	'America/Santa_Isabel',
	'Mexico/BajaNorte',
	'Mexico/BajaSur',
	'Mexico/General',
]);

export function defaultContactMethod() {
	const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	return qrTimeZones.has(timeZone) ? 'qr' : 'form';
}

// Record the attempt first so a failed update does not retry over later choices.
export async function applyContactDefaults(idb) {
	try {
		if (await idb.get('settings', 'regionalContactDefaultsAttempted')) return;
		await idb.put('settings', true, 'regionalContactDefaultsAttempted');
		if (defaultContactMethod() !== 'qr') return;
		const contact = await idb.get('settings', 'contact') ?? {};
		await idb.put('settings', { ...contact, method: 'qr', destination: 'usa' }, 'contact');
	} catch {
		// Keep the saved settings if the one-time update fails.
	}
}

export const contactDestinations = {
	usa: { label: 'contact.usaPage', flag: 'us', url: 'https://us.safandarley.com/sales-and-contact/' },
	netherlands: { label: 'contact.netherlandsPage', flag: 'nl', url: 'https://safandarley.com/nl/contact' },
	uk: { label: 'contact.ukPage', flag: 'gb', url: 'https://safandarley.com/uk/contact' },
};

export function validContactUrl(value) {
	if (typeof value !== 'string' || !/^https?:\/\//i.test(value.trim())) return '';
	try {
		const url = new URL(value.trim());
		return url.hostname && !url.username && !url.password && url.href.length <= 2000 ? url.href : '';
	} catch {
		return '';
	}
}

export function contactUrl(settings) {
	return settings.destination === 'custom' ? validContactUrl(settings.customUrl) : (contactDestinations[settings.destination]?.url || contactDestinations.usa.url);
}
